module.exports = __webpack_public_path__ + "images/花筑院子全景_04-1.jpg?v=34d71753";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_04-1.jpg
 ** module id = 72
 ** module chunks = 1 2
 **/